import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Toolbar,
  Edit,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./grid.css";
import { toast } from "react-hot-toast";
import { getGvgOrder } from "../../api/PupilApi";
import { IoCloudDownload } from "react-icons/io5";


function AdminDashboardOrder() {
  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [chitData, setChitData] = useState([]);
  const [email, setEmail] = useState("");
  const [selectedUserEmail, setSelectedUserEmail] = useState("");

  const editparams = { params: { popupHeight: "300px" } };
  const validationRule = { required: true };
  const emailRules = { required: true, text: true };

  const selectionSettings = { persistSelection: true };
  const format = { type: "dateTime", format: "M/d/y hh:mm a" };
  const droplist = [
    { text: "Top", value: "Top" },
    { text: "Bottom", value: "Bottom" },
  ];

  const toolbarOptions = ["Search"];
  const pageSettings = { pageCount: 5 };
  const editSettings = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    newRowPosition: "Top",
  };

  // Load order data on component mount
  useEffect(() => {
    loadOrderData();
  }, []);

  const loadOrderData = () => {
    setLoading(true);
    getGvgOrder()
      .then((res) => {
        toast.success(res.data.message);
        setOrderData(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message);
        } else {
          toast.error("Sorry! Something went wrong. Please try again!");
        }
        setLoading(false);
        console.log(error);
      });
  };

 
  const handleRowSelect = (args) => {
    if (args.data && args.data.email) {
      setSelectedUserEmail(args.data.email);
    }
  };

  const actionTemplate = (props) => {
    return (
      <Link
        to={{
          pathname: "/viewOrderList",
        }}
        state={{
          name: props.name,
          email: props.email,
          orderList: props.orderList,
        }}
        exact
      >
        <button
          className="px-2 text-sm border-1 border-brightColor bg-backgroundColor hover:text-brightColor transition-all rounded-lg font-bold uppercase"
          type="button"
        >
          <span>
            <IoCloudDownload />
          </span>
        </button>
      </Link>
    );
  };

  const chitActionTemplate = (props) => {
    return (
      <button
        className="px-2 text-sm border-1 border-brightColor bg-backgroundColor hover:text-brightColor transition-all rounded-lg font-bold uppercase"
        type="button"
        onClick={() => setSelectedUserEmail(props.email)}
      >
        View Chits
      </button>
    );
  };

  return (
    <div className="control-pane flex-1 m-5">
      <div className="control-section">
        <h2 className="text-xl font-bold mb-4">Order Data</h2>
        <GridComponent
          dataSource={orderData}
          enableHover={true}
          allowPaging
          pageSettings={pageSettings}
          selectionSettings={selectionSettings}
          toolbar={toolbarOptions}
          editSettings={editSettings}
          allowFiltering={false}
          allowGrouping={true}
          allowPdfExport={true}
          allowSorting
          rowSelected={handleRowSelect}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="name"
              headerText="Name"
              width="150"
              textAlign="Center"
              isPrimaryKey={true}
            />
            <ColumnDirective
              field="email"
              headerText="Email"
              width="150"
              textAlign="Center"
            />
            <ColumnDirective
              field="mobile"
              headerText="Mobile No"
              width="150"
              textAlign="Center"
            />
            <ColumnDirective
              field="orderList"
              headerText="Order List"
              width="150"
              textAlign="Center"
              template={actionTemplate}
            />
            <ColumnDirective
              field="paymentStatus"
              headerText="Payment Status"
              width="150"
              textAlign="Center"
            />
            <ColumnDirective
              field="email"
              headerText="Chit Data"
              width="150"
              textAlign="Center"
              template={chitActionTemplate}
            />
          </ColumnsDirective>
          <Inject services={[Page, Toolbar, Edit]} />
        </GridComponent>
      </div>

      {chitData.length > 0 && (
        <div className="control-section mt-8">
          <h2 className="text-xl font-bold mb-4">
            Chit Data for {selectedUserEmail}
          </h2>
          <GridComponent
            dataSource={chitData}
            enableHover={true}
            allowPaging
            pageSettings={pageSettings}
            toolbar={toolbarOptions}
            allowFiltering={false}
            allowGrouping={true}
            allowPdfExport={true}
            allowSorting
          >
            <ColumnsDirective>
              <ColumnDirective
                field="planName"
                headerText="Plan Name"
                width="150"
                textAlign="Center"
              />
              <ColumnDirective
                field="amount"
                headerText="Amount"
                width="150"
                textAlign="Center"
              />
              <ColumnDirective
                field="duration"
                headerText="Duration"
                width="150"
                textAlign="Center"
              />
              <ColumnDirective
                field="status"
                headerText="Status"
                width="150"
                textAlign="Center"
              />
            </ColumnsDirective>
            <Inject services={[Page, Toolbar]} />
          </GridComponent>
        </div>
      )}
    </div>
  );
}

export default AdminDashboardOrder;